var React = require('react');

function Features (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#86888b"},React.createElement("path",{"d":"M8.11 23.26v-.14c0-2.55 1.78-3.86 4.35-3.86a8 8 0 0 1 2.79.5v-.53a2.36 2.36 0 0 0-2.66-2.55 6.78 6.78 0 0 0-2.92.75l-.73-2a8.66 8.66 0 0 1 4-.94 4.71 4.71 0 0 1 3.51 1.21 4.63 4.63 0 0 1 1.21 3.47v7.54h-2.43v-1.5A3.88 3.88 0 0 1 11.85 27a3.58 3.58 0 0 1-3.74-3.74zm7.19-.6v-1.27A6.55 6.55 0 0 0 13 21c-1.52 0-2.42.79-2.42 2.09v.06a1.89 1.89 0 0 0 2 2 2.52 2.52 0 0 0 2.72-2.49zM20.36 20.84v-.31c0-4.07 2.26-6.13 4.71-6.13a4.17 4.17 0 0 1 3.56 2.13v-1.89h2.5v12.09h-2.5v-2A4.12 4.12 0 0 1 25.07 27c-2.45 0-4.71-2.07-4.71-6.16zm8.33-.05v-.22c0-2.44-1.38-4-3-4s-2.88 1.5-2.88 4v.2c0 2.49 1.3 4 2.88 4s3-1.56 3-3.98z"})));
}

Features.defaultProps = {"id":"Layer_1","viewBox":"0 0 40 42"};

module.exports = Features;

Features.default = Features;
